
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { Table, Autocomplete, TableBody, Grid, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useAccesos } from '../contexts/AccesosContext';


function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}



function AddComentario ({ handleNewComentario, editComentario, idOportunidad, cancelarEdicion }){
     // Estado para el título, descripción y selección del ComboBox
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [comentarioDescripcion, setComentarioDescripcion] = useState('');  
    const [oportunidad, setOportunidad] = useState([])
    const [etapaOportunidad, setEtapaOportunidad] = useState([])
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');  
 
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
        // Obtener la fecha y hora actual
        function obtenerFechaISOsinZ() {
            const fecha = new Date();
            let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
            fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
            return fechaISO;
    }
 

    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();
    // Carga inicial de datos si estamos en modo edición
      useEffect(() => {
        if (editComentario) {
        
            setComentarioDescripcion(editComentario.comentario); // Cargar la descripción de la raza para editar
            setModificacion(2);
            setIngresadoPor(editComentario.ingresadoPor);
          
      
        } else {
            setComentarioDescripcion('');
            setModificacion(1);
            setIngresadoPor('');
      
        }
    }, [editComentario]);



    const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editComentario? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editComentario ? `${server}/CrmComentarios/${editComentario.id}` : `${server}/CrmComentarios`;
    
            const comentario = { 
                id:editComentario ? editComentario.id:0,
                comentario: comentarioDescripcion,
                idOportunidad, //almacena el id de campania correspondiente
                // idEtapaOportunidad,
                IngresadoPor: !editComentario ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editComentario ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                modificacion,
                fechaIngreso: fechaFormateada
            };


        

            Object.keys(comentario).forEach(key => comentario[key] === undefined && delete comentario[key]);

            
            // console.log(endpoint)
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(comentario),
                });
    
                if (response.ok) {
                    // Limpiar el formulario y manejar la respuesta si es necesario
                    setComentarioDescripcion('');
                    setModificacion(1);
                    setIngresadoPor('');
                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                    handleNewComentario();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar el comentario',
                    text: error || 'Ocurrió un error inesperado',
                });        }
        };


        const handleCancelarEdicion = () => {
            setComentarioDescripcion('');
            setModificacion(1);
            setIngresadoPor('');
            if (cancelarEdicion) cancelarEdicion();
        }
    

    return (
        <>
        <h2>{editComentario ? 'Editar Comentario' : 'Agregar Nuevo Comentario'}</h2>
        <br />
        <form onSubmit={handleSubmit} className="form-horizontal form-label-left" >
            <div className="item form-group">
            <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="comentario">
                    Comentario: <span className="required">*</span>
                </label>
                <div className="col-md-8 col-sm-3">
                    <textarea
                        type="text"
                        id="comentario"
                        required="required"
                        className="form-control"
                        value={comentarioDescripcion}
                        onChange={(e) => setComentarioDescripcion(e.target.value)}
                        
                        
                    />
                </div>
            </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Comentario CRM')}>
                        {editComentario ? 'Actualizar' : 'Guardar'}
                    </button>
                    {editComentario && (
                        <button type="button" className="btn btn-secondary" onClick={handleCancelarEdicion}>
                            Cancelar
                        </button>  
                    )}
                </div>
            </div>
        </form>
    </>
    )
}


export default AddComentario;